export default __webpack_public_path__ + "static/media/in-storage.770ca72a.svg";